import BottomGraph from "./BottomGraph";

export default BottomGraph;